// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1PlfN","title":"ClientInsurance_title__2S56W","itemText":"ClientInsurance_itemText__13828"};